import cards from "../../../../src/contentCard/course/introducing-yourself";
import quiz from "../../../../src/contentQuiz/course/introducing-yourself";
import * as React from 'react';
export default {
  cards,
  quiz,
  React
};